"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _core = require("../core");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var FeFooter = function FeFooter(props) {
  /** Minimum condition required to render*/

  /** Rendering of component */
  var className = (0, _classnames.default)('fe-footer', props.className);
  var otherProps = Object.assign({}, props);
  delete otherProps.prop;
  return _react.default.createElement("div", {
    className: className
  }, _react.default.createElement(Copyright, {
    copyrightMessage: props.copyrightMessage
  }), props.children, props.footerLinks && _react.default.createElement("ul", {
    className: "fe-footer__link-list"
  }, props.footerLinks.map(function (item, key) {
    return _react.default.createElement("li", {
      className: "fe-footer__item",
      key: key
    }, _react.default.createElement(FooterLink, {
      href: item.href,
      route: item.route,
      customRenderLink: item.customRenderLink,
      iconClass: item.icon
    }, item.label));
  })));
};

var Copyright = function Copyright(props) {
  return _react.default.createElement("div", {
    className: "fe-footer__item"
  }, props.copyrightMessage);
};

var FooterLink = function FooterLink(props) {
  var Link = props.customRenderLink || _core.FeDefaultLink;
  return _react.default.createElement(Link, {
    href: props.href,
    route: props.route
  }, _react.default.createElement("i", {
    className: props.iconClass
  }), props.children);
};

FeFooter.defaultProps = {
  copyrightMessage: "\xA9 ".concat(new Date().getFullYear(), " FireEye, Inc.")
};
FeFooter.propTypes = {
  /** Copyright Text */
  copyrightMessage: _propTypes.default.string,

  /** Provide footer link item*/
  footerLinks: _propTypes.default.arrayOf(_propTypes.default.shape({
    href: _propTypes.default.string,
    route: _propTypes.default.string,
    icon: _propTypes.default.string,
    label: _propTypes.default.string
  }))
};
FeFooter.displayName = 'FeFooter';
var _default = FeFooter;
exports.default = _default;